import Vue from 'vue';

export const toastMixin = Vue.extend({
    methods: {
        popupToast(titleKey: string, messageKey: string, prefix?: string) {
            if (prefix && prefix.length) {
                titleKey = `${prefix}.${titleKey}`;
                messageKey = `${prefix}.${messageKey}`;
            }

            const translatedTitle = this.$i18n.t(titleKey);
            const translatedMessage = this.$i18n.t(messageKey);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });
        }
    }
});
